import { Container } from '@wyz/ui';
import { invariant } from '@wyz/utils';
import { RedistributionServiceApplicationStep } from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';
import { PRICING_STATUS_ENUM } from '~/purchase/schemas';
import {
  IPricingStatus,
  IRedistributionServicePricingForm,
} from '~/purchase/types';

type Props = {
  onSubmit: (
    formData: IRedistributionServicePricingForm,
    status: IPricingStatus,
  ) => void;
  defaultValues?: IRedistributionServicePricingForm;
  isSubmitting: boolean;
  policyGroupId?: number;
};

function RedistributionServicePricingPoliciesForm({
  onSubmit,
  defaultValues,
  isSubmitting,
  policyGroupId,
}: Props) {
  const { state } = usePurchaseContext();
  invariant(state.targetCustomer);

  return (
    <>
      <Container>
        <RedistributionServiceApplicationStep
          initialValues={defaultValues}
          onSubmit={(formData) => {
            onSubmit(formData, PRICING_STATUS_ENUM.ENABLED);
          }}
          isSubmitting={isSubmitting}
          customerId={state.targetCustomer.id}
          policyGroupId={policyGroupId}
        />
      </Container>
    </>
  );
}

export default RedistributionServicePricingPoliciesForm;
